'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _bulkUsageData = require('./bulk-usage-data.component');

var _bulkUsageData2 = _interopRequireDefault(_bulkUsageData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.dashboard.bulk-usage-data', []).component('bulkUsageData', _bulkUsageData2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/common/bulk-usage-data/bulk-usage-data.module.js